import React, { useState } from 'react'
import { Form, Input, Button, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import api from '../api'
import useStore from '../store'

export default function Login() {
  const [loading, setLoading] = useState(false)
  const { setAuth } = useStore()
  const navigate = useNavigate()

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const data = await api.post('/auth/login', values)
      setAuth(data.user, data.token)
      navigate('/')
    } catch (err) {
      message.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f1b35 0%, #1a2d5a 50%, #0f1b35 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Background decoration */}
      <div style={{
        position: 'absolute', width: 400, height: 400, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(22,119,255,0.15) 0%, transparent 70%)',
        top: -100, right: -100,
      }} />
      <div style={{
        position: 'absolute', width: 300, height: 300, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(64,150,255,0.1) 0%, transparent 70%)',
        bottom: -50, left: -50,
      }} />

      <div style={{
        background: 'rgba(255,255,255,0.97)',
        borderRadius: 20,
        padding: '48px 44px',
        width: 400,
        boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            display: 'inline-block',
            background: '#111',
            borderRadius: 10,
            padding: '10px 24px',
            marginBottom: 16,
          }}>
            <span style={{
              fontFamily: "'Inter', 'Arial Black', sans-serif",
              fontWeight: 900, fontSize: 22, letterSpacing: 5,
              textTransform: 'uppercase',
            }}>
              <span style={{ color: '#fff' }}>KING</span>
              <span style={{ color: '#c8922a' }}>ROAD</span>
            </span>
          </div>
          <p style={{ color: '#6b7280', fontSize: 14, margin: 0 }}>请登录您的账户</p>
        </div>

        <Form onFinish={onFinish} size="large" layout="vertical">
          <Form.Item name="email" rules={[{ required: true, message: '请输入邮箱' }]}>
            <Input
              prefix={<UserOutlined style={{ color: '#9ca3af' }} />}
              placeholder="邮箱地址"
              style={{ borderRadius: 10, height: 46 }}
            />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: '#9ca3af' }} />}
              placeholder="密码"
              style={{ borderRadius: 10, height: 46 }}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
            <Button
              type="primary" htmlType="submit" loading={loading} block
              style={{
                height: 46, borderRadius: 10, fontWeight: 600, fontSize: 15,
                background: 'linear-gradient(90deg, #1677ff, #4096ff)',
                border: 'none', boxShadow: '0 4px 14px rgba(22,119,255,0.4)',
              }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
